import React, { useEffect } from "react";
import { IoArrowBack } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import {
  saveNotes,
  setActiveScreen,
  setCurrentNote,
} from "../../store/reducers/notepad";
import { AppDispatch, RootState } from "../../store";
import axiosInstance from "config/axios";

const AddNote = () => {
  const dispatch = useDispatch<AppDispatch>();
  const profileData = useSelector((state: RootState) => state.auth.user);
  const session_id = useSelector((state: RootState) => state.live.settings.roomId);

  const sessionData = useSelector((state: RootState) => state.live.settings.session);

  const { currentNote, id } = useSelector((state: RootState) => state.live.notepad);
  const { user } = useSelector((state: RootState) => state.auth);
  const roomId = useSelector((state: RootState) => state.live.settings.roomId);

  const [note, setNote] = React.useState({
    title: currentNote?.title || "",
    content: currentNote?.content || "",
    session_name: sessionData?.session?.session_name || "",
    program_name: sessionData?.session?.program?.program_name || "",
  });

  useEffect(() => {
    setNote({
      title: currentNote?.title || "",
      content: currentNote?.content || "",
      session_name: sessionData?.session?.session_name || "",
      program_name: sessionData?.session?.program?.program_name || "",
    });
  }, [currentNote, sessionData]);

  const handleChange = (name: string, value: string) => {
    setNote((prev) => ({ ...prev, [name]: value }));
  };

  const handleBack = () => {
    if (!note.title && !note.content) {
      dispatch(setActiveScreen(1));
      dispatch(setCurrentNote(null));
      return;
    }

    dispatch(saveNotes({
      noteData: note,
      id,
      sessionSegmentId: sessionData.id
    })).then(() => {
      dispatch(setActiveScreen(1));
      dispatch(setCurrentNote(null)); // Reset currentNote after saving
      saveActions();
    });
  };

  const saveActions = async () => {
    const session = await axiosInstance.post("/trainee/live_session_plan_preview_trainee", {
      session_map_id: roomId
    });

    const responseData = session?.data?.responseData || {};
    const allActivities = [
      ...(responseData.prePlannedActivities || []),
      ...(responseData.quickSetupActivities || [])
    ];

    const launchData = allActivities.find((el: any) => el.status === "LAUNCH");
    if (!launchData?.id) {
      return;
    }

    const engagementType = "L_JOURNALING";
    const obj = {
      engagementType,
      userId: user?.id,
      sessionActivityExecutionLogId: launchData?.id,
      isRead: "NO",
      participantId: user?.id,
      subType: null
    };

    await axiosInstance.post("/session/save_session_actions_log", obj);
  };

  return (
    <div className="w-full h-full bg-[#24272C] text-white rounded-xl overflow-hidden">
      <div className="flex items-center p-4">
        <button className="text-white text-2xl" onClick={handleBack}>
          <IoArrowBack />
        </button>
        <h2 className="text-lg font-semibold ml-4">Notepad</h2>
      </div>

      <div className="px-4 py-6 bg-[#24272C] h-full flex flex-col gap-4">
        <input
          id="title"
          name="title"
          className="w-full rounded-full bg-[#84889C] bg-opacity-30 text-white text-base px-4 py-2 focus:outline-none placeholder:text-white placeholder:opacity-70"
          placeholder="Title"
          value={note.title}
          onChange={(e) => handleChange("title", e.target.value)}
        />

        <textarea
          id="content"
          name="content"
          className="w-full flex-grow bg-[#84889C] bg-opacity-30 text-white text-base px-4 py-4 rounded-2xl focus:outline-none placeholder:text-white placeholder:opacity-70 resize-none"
          placeholder="Type something..."
          value={note.content}
          onChange={(e) => handleChange("content", e.target.value)}
        />
      </div>
    </div>
  );
};

export default AddNote;

